import { View, YStack, XStack, Text, Button } from "tamagui";
import { colors } from "@styles/colors";
import { RiArrowLeftSLine, RiVisaLine, RiMastercardFill } from "react-icons/ri";
import TextCustom, { TextSize } from "@components/TextCoustom";
import Steper from "@screen/Register/components/Steper";

export const RADIUS = 12;
export const SHEET_RADIUS = 18;

export function Header({
  title,
  sub,
  step,
  total,
  onBack,
}: {
  title: string;
  sub?: string;
  step?: number;
  total?: number;
  onBack?: () => void;
}) {
  return (
    <View style={{ position: "sticky" as any, top: 0, zIndex: 1000 }} width="100%" bg={colors.bg}>
      <YStack className="app-header-gradient" p={20} borderRadius={30} btrr={0} btlr={0}>
        <XStack ai="center" jc="space-between" mb="$3">
          <XStack ai="center" gap="$1" cursor="pointer" ml="$-2" onPress={onBack} opacity={onBack ? 1 : 0} pointerEvents={onBack ? "auto" : "none"}>
            <RiArrowLeftSLine size={20} color={colors.light} />
            <TextCustom str="返回" type={TextSize.SMALL} color={colors.light} bold />
          </XStack>
        </XStack>
        <YStack ai="flex-start" mb="$2">
          <TextCustom str={title} type={TextSize.SUBLARGE} color={colors.light} bold align="right" />
          {sub && (
            <Text fontSize={12} color="rgba(255,255,255,0.8)" mt="$1" fontWeight="600" ta="right">
              {sub}
            </Text>
          )}
        </YStack>
        {step != null && total != null && (
          <XStack>
            <Steper total={total} current={step} />
          </XStack>
        )}
      </YStack>
    </View>
  );
}

export const Fade = ({ children, i = 0 }: { children: React.ReactNode; i?: number }) => (
  <View animation="quick" enterStyle={{ opacity: 0, y: 8 }} opacity={1} y={0} style={{ transitionDelay: `${i * 30}ms` }}>
    {children}
  </View>
);

export function StickyBtn({
  label,
  disabled,
  onClick,
  icon,
  color = colors.primary,
  shadowColor,
}: {
  label: string;
  disabled?: boolean;
  onClick: () => void;
  icon?: any;
  color?: string;
  shadowColor?: string;
}) {
  return (
    <YStack backgroundColor={colors.bg} style={{ position: "sticky", bottom: "0", width: "100%", zIndex: 100 }}>
      <XStack
        className="primary-bg-gradient"
        borderRadius={20}
        p={15}
        alignItems="center"
        justifyContent="center"
        opacity={disabled ? 0.5 : 1}
        cursor={disabled ? "default" : "pointer"}
        onPress={() => !disabled && onClick()}
        style={{ boxShadow: disabled ? "none" : `0 4px 16px ${shadowColor || color}40` }}>
        <XStack gap={10} ai="center">
          {icon}
          <Text color="white" fontSize={16} fontWeight="bold">
            {label}
          </Text>
        </XStack>
      </XStack>
    </YStack>
  );
}

export const detectCard = (digits: string) => {
  if (/^4/.test(digits)) return { name: "Visa", color: "#1A1F71", icon: <RiVisaLine size={20} /> };
  if (/^5[1-5]/.test(digits) || /^2[2-7]/.test(digits)) return { name: "Mastercard", color: "#EB001B", icon: <RiMastercardFill size={20} /> };
  if (/^35/.test(digits)) return { name: "JCB", color: "#007AC2", icon: "J" };
  if (/^3[47]/.test(digits)) return { name: "AmEx", color: "#007AC2", icon: "A" };
  if (/^(62|88)/.test(digits)) return { name: "UnionPay", color: "#E21836", icon: "U" };
  return null;
};

export const fmtCard = (v: string) => v.replace(/\D/g, "").slice(0, 16).replace(/(.{4})/g, "$1 ").trim();
export const fmtExpiry = (v: string) => {
  const d = v.replace(/\D/g, "").slice(0, 4);
  return d.length > 2 ? d.slice(0, 2) + "/" + d.slice(2) : d;
};
